import { render, staticRenderFns } from "./TestAndTaskDetail.vue?vue&type=template&id=1222bfd6&scoped=true&"
import script from "./TestAndTaskDetail.vue?vue&type=script&lang=js&"
export * from "./TestAndTaskDetail.vue?vue&type=script&lang=js&"
import style0 from "./TestAndTaskDetail.vue?vue&type=style&index=0&id=1222bfd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1222bfd6",
  null
  
)

export default component.exports